import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";
import ConnectivityGroup from "../../../../groups/ConnectivityGroup";

class MetricLivePricingOtherReasonCount extends MetricBase {
    constructor() {
        super({
            field: "metric_livePricingOtherReasonCount",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.livePricingOtherReasonCount.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.livePricingOtherReasonCount.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.livePricingOtherReasonCount.tooltip"),
            group: new ConnectivityGroup(),
        });
    }
}

export default MetricLivePricingOtherReasonCount;
